import classNames from 'classnames';
import { RevealingPointsWithSubServices } from '@sapientpro/sapientpro-data-models';
import Button, { ButtonVariants } from '../Button';
import styles from './RevealingCaseSection.module.scss';

interface IRevealingCasePointProps {
  point: RevealingPointsWithSubServices;
  handleClick: () => void;
  isActive: boolean;
}

const RevealingCasePoint = ({ point, handleClick, isActive }: IRevealingCasePointProps) => (
  <div
    className={styles.revealingCaseSection__contentListItem}
  >
    <button
      type='button'
      onClick={handleClick}
      className={classNames(styles.revealingCaseSection__contentListItemButton, 'header4', {
        [styles.revealingCaseSection__contentListItemButton_active]: isActive,
      })}
    >
      {point.title}
      <svg className={styles.revealingCaseSection__contentListItemButtonIcon}>
        <use
          xlinkHref='/media/arrow-right-bold.svg#arrowRight'
          href='/media/arrow-right-bold.svg#arrowRight'
        />
      </svg>
    </button>
    <div
      className={classNames(styles.revealingCaseSection__contentListItemContent, {
        [styles.revealingCaseSection__contentListItemContent_hidden]: !isActive,
      })}
    >
      <p className={classNames(styles.revealingCaseSection__contentListItemContentDescription, 'bodyLarge')}>
        {point.description}
      </p>
      {point.subService && (
      <Button
        className={styles.revealingCaseSection__contentListItemContentButton}
        variant={ButtonVariants.TRANSPARENT}
        icon={(
          <svg
            className={styles.revealingCaseSection__contentListItemContentButtonIcon}
            viewBox='0 0 24 24'
          >
            <use
              xlinkHref='/media/arrow-right-bold.svg#arrowRight'
              href='/media/arrow-right-bold.svg#arrowRight'
            />
          </svg>
                    )}
        iconPosition='right'
        iconSize={{ width: 24, height: 24 }}
        link={point.subService?.slug}
      >
        Read more
      </Button>
      )}
    </div>
  </div>
);

export default RevealingCasePoint;
